<template>
  <div class="rd-screen">
    <report-tools :copy="slips.length > 0" @copy="copyOrders">
      <ui-chips v-if="shifts.length" v-model="selectedShift" :options="shifts.map((value) => ({ value }))" :label="$t('shifts')">
        <template #option="{ option }">
          <report-shift-tag :shift="Number(option.value)" long></report-shift-tag>
        </template>
      </ui-chips>
    </report-tools>

    <report-state v-if="isRange" icon="mdi-calendar-today" :title="$t('daily_report')"></report-state>
    <report-state
      v-else-if="!selectedCompany"
      icon="mdi-domain"
      :title="$t('report_mobile.employees_pick_company')"
    ></report-state>
    <report-state v-else-if="loading" kind="loading"></report-state>
    <report-state
      v-else-if="!slips.length"
      icon="mdi-food-off"
      :title="emptyTitle"
      :text="emptyText"
    ></report-state>

    <section v-else class="rd-slips">
      <div class="rd-slips__head">
        <report-shift-tag :shift="Number(selectedShift)" long></report-shift-tag>
        <i class="rd-order-card__rule"></i>
        <span class="rd-num">{{ summary }}</span>
      </div>

      <div class="rd-slips__grid">
        <article v-for="slip in slips" :key="slip.key" class="rd-slip" :data-shift="selectedShift">
          <header class="rd-slip__head">
            <span class="ui-avatar ui-avatar--neutral ui-avatar--sm">{{ slip.initials }}</span>
            <b class="rd-slip__name" :title="`ID ${slip.userId}`">{{ slip.name }}</b>
            <span class="rd-slip__no rd-num">#{{ slip.id }}</span>
          </header>
          <ul>
            <template v-for="category in slip.categories">
              <li :key="`${category.name}-title`" class="gm-slip__cat">{{ category.name }}</li>
              <li v-for="(meal, index) in category.meals" :key="`${category.name}-${index}`">
                <b class="rd-num">{{ meal.quantity }}× </b>
                <span>{{ meal.name }}</span>
              </li>
            </template>
          </ul>
        </article>
      </div>
    </section>
  </div>
</template>

<script>
import ReportTabGroupMealsTabOrders from "@/components/report/group-meals/ReportTabGroupMealsTabOrders.vue";
import hasPlural from "../../../shared/hasPlural";
import hasGroupSlips from "../../../shared/group/hasGroupSlips";
import ReportShiftTag from "../../../shared/ReportShiftTag.vue";
import { copyText, rowsToTsv } from "../../copyTable";
import ReportState from "../../ReportState.vue";
import ReportTools from "../../ReportTools.vue";

/**
 * Naručeno (jela iz grupa) na računaru: jedna firma i jedna smena (oznake smena u alatima), kartica po radniku sa
 * obrocima po grupama jela. Radi samo za jedan dan. Firmu i pretragu čita iz zajedničke trake. Nasleđuje učitavanje,
 * štampu i Excel iz starog taba.
 */
export default {
  name: "ReportDesktopGroupOrdered",
  extends: ReportTabGroupMealsTabOrders,
  mixins: [hasPlural, hasGroupSlips],
  components: { ReportShiftTag, ReportState, ReportTools },
  computed: {
    summary() {
      return [
        this.pluralT("report_mobile.workers_n", this.slips.length),
        this.pluralT("report_mobile.dishes_n", this.mealTotal),
      ].join(" · ");
    },
    emptyTitle() {
      return this.filters.search
        ? this.$t("report_mobile.no_results_for", { search: this.filters.search })
        : this.$t("no_orders_found");
    },
    emptyText() {
      return this.filters.search ? "" : this.$t("report_desktop.empty_hint");
    },
    kpis() {
      return [
        { key: "workers", label: this.$t("report_desktop.workers"), value: this.slips.length, tone: "inverse" },
        { key: "meals", label: this.$t("report_desktop.total_dishes"), value: this.mealTotal },
      ];
    },
  },
  watch: {
    kpis: {
      handler(kpis) {
        this.$emit("kpis", this.slips.length ? kpis : []);
      },
      immediate: true,
    },
    loading: {
      handler(loading) {
        this.$emit("loading", loading);
      },
      immediate: true,
    },
  },
  methods: {
    async copyOrders() {
      const headers = [this.$t("worker"), "#", this.$t("report_group.categories"), this.$t("meals")];
      const rows = this.slips.flatMap((slip) =>
        slip.categories.map((category) => [
          slip.name,
          slip.id,
          category.name,
          category.meals.map((meal) => `${meal.quantity}× ${meal.name}`).join("; "),
        ])
      );
      const copied = await copyText(rowsToTsv(headers, rows));
      this.$emit("toast", this.$t(copied ? "report_desktop.copied" : "report_desktop.copy_failed"));
    },
  },
};
</script>
